import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const componentRecommendationConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default componentRecommendationConfig;
